import { createAction, props } from '@ngrx/store';
import { SitemapEntry } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStatus } from '@wdx/shared/utils';

export const updateExtendedRouteState = createAction(
    '[Extended Route] Update Extended Route State',
    props<{
        status: CrudStatus;
        sitemapEntry?: SitemapEntry;
        parentSitemapEntries?: SitemapEntry[];
        wholeSitemap?: SitemapEntry[];
        isAdminArea?: boolean;
    }>(),
);

export const refreshExtendedRouteState = createAction(
    '[Extended Route] Refresh Extended Route State',
);

export const clearExtendedRouteState = createAction(
    '[Extended Route] Clear Extended Route State',
);
